/**
 * Direct Klaviyo signup for the first-order free-shipping promo page.
 * Uses the public Client Subscriptions API; private credentials never reach
 * the browser. Success is shown only after Klaviyo accepts the request.
 */
(function () {
  function wire(form) {
    if (form.__klaviyoNewsletterWired) return;
    form.__klaviyoNewsletterWired = true;

    const configNode = form.querySelector('[data-klaviyo-newsletter-config]');
    const emailInput = form.querySelector('input[name="email"]');
    const submitButton = form.querySelector('[data-klaviyo-newsletter-submit]');
    const status = form.querySelector('[data-klaviyo-newsletter-status]');
    let config = {};

    try { config = JSON.parse(configNode.textContent); } catch (error) {}

    function show(message, isError) {
      status.textContent = message;
      status.hidden = false;
      status.classList.toggle('is-error', isError);
      status.classList.toggle('is-success', !isError);
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      const email = emailInput.value.trim();
      if (!email || !emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      if (!config.public_key || !config.list_id) {
        show('Email signup is temporarily unavailable. Please try again later.', true);
        return;
      }

      const originalLabel = submitButton.textContent;
      submitButton.disabled = true;
      submitButton.textContent = 'Sending…';
      status.hidden = true;

      const body = {
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            custom_source: config.source || 'Website newsletter signup'
          },
          relationships: {
            list: { data: { type: 'list', id: config.list_id } }
          }
        }
      };

      try {
        const response = await fetch(
          'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(config.public_key),
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify(body)
          }
        );

        if (!response.ok) throw new Error('Klaviyo request failed with status ' + response.status);

        form.dataset.state = 'success';
        emailInput.disabled = true;
        submitButton.textContent = 'Code sent ✓';
        show('Check your inbox—your free-shipping code is on the way.', false);
      } catch (error) {
        form.dataset.state = 'error';
        submitButton.disabled = false;
        submitButton.textContent = originalLabel;
        show('Something went wrong. Please try again.', true);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-klaviyo-newsletter]').forEach(wire);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
